export function getSchemaFieldNames(schema) {
  const schemaDescription = schema.describe();
  return Object.keys(schemaDescription.fields);
}